// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
//const $ = require( "jquery" )( window );
// import jquery from 'jquery';
// window.jQuery = jquery;
// window.$ = jquery;
// const $ = require( "jquery" )( window );
// const jQuery = require( "jquery" )( window );
//import vuetify from '@/plugins/vuetify'; // path to vuetify export
//import { preset } from 'vue-cli-plugin-vuetify-preset-basil/preset'
//import {VLazy, VSkeletonLoader, VTabs, VTab, VTabsItems, VTabItem, VAvatar, VRating, VBadge} from 'vuetify/lib';

// import * as svgicon from 'vue-svgicon';
// import '@/assets/sprite/icon/svg';

import '@/assets/css/bootstrap-grid.min.css';
import '@/assets/css/jquery.fancybox3.css';
import '@/assets/css/normalize.css';
import '@/assets/css/reset.css';
import '@/assets/css/base.scss';


import axios from 'axios';
import "@/mixins/mixins.js";
import VueMask from 'v-mask';
//import catalog from '@/mixins/catalog';


//import "https://code.jquery.com/jquery-3.6.3.min.js";
//import "@/plugins/bodyScrollLock.min.js";
import "@fancyapps/fancybox";
import "@/mixins/main.js";
const  ActionItem = () => import ('@/components/giulia/ActionItem');
//const  ArticleItem = () => import ('@/components/giulia/ArticleItem');
//const  Aside = () => import ('@/components/giulia/Aside');
const  CommentItem = () => import ('@/components/giulia/CommentItem');
const  FacadesBlock = () => import ('@/components/giulia/FacadesBlock');
const  Figure = () => import ('@/components/giulia/Figure');
//const  Footer = () => import ('@/components/giulia/Footer');
const  Intro = () => import ('@/components/giulia/Intro');
const  MobileFilter = () => import ('@/components/giulia/MobileFilter');
//const  Nav = () => import ('@/components/giulia/Nav');
const  PageBlock = () => import ('@/components/giulia/PageBlock');
const  PageHeading = () => import ('@/components/giulia/PageHeading');
//const  Header = () => import ('@/components/giulia/Header');
const  Quizze = () => import ('@/components/giulia/Quizze');
const  SliderBlock = () => import ('@/components/giulia/SliderBlock');
const  TipsBlock = () => import ('@/components/giulia/TipsBlock');
const  Map = () => import ('@/components/giulia/Map');
const FileUpload = () => import('vue-upload-component');
//const Pagination = () => import('@/components/pagination');

import Header from '@/components/giulia/Header';
import Aside from '@/components/giulia/Aside';
import CarouselItems from '@/components/giulia/CarouselItems';
import ArticleItem from '@/components/giulia/ArticleItem';
import Pagination from '@/components/pagination';
//const CarouselItems = () => import('@/components/giulia/CarouselItems');



//window.Swiper = Swiper;



if(window.location.search) {
  const params = new URLSearchParams(window.location.search);
  if(params.get('showMargins')) {
      setTimeout(() => this.showMargins(), 2000);
  }
}


if($("#static_page").length > 0)
{
  let static_page = {el:"#static_page",
                     data:{  

                    },
          };

  window.global_vue.push(static_page);
}





function formatData(number){

  let floatNum = parseFloat(number);

  
  if(floatNum < 1000)
  {
    return String(floatNum);
  }
  else
  {
    return floatNum.toLocaleString('ru');
  }
  
}


Vue.directive('numflip', {
       
  bind: function(el, binding) {
    //el.setAttribute("value", parseFloat(binding.value).toLocaleString('ru'));
    el.value = formatData(binding.value);
  },
  update: function (el, binding, vnode) {
    var numberAnimation = function(el, oldValue, newValue) {
      var start = null, duration = 200
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        el.value = formatData(Math.round(oldValue + (newValue-oldValue)*progress/duration));
       // el.setAttribute("value", Math.round(oldValue + (newValue-oldValue)*progress/duration).toLocaleString('ru'));
        
        if (progress < duration) {
          window.requestAnimationFrame(step);
        } else {
          el.value = formatData(newValue);
          //el.setAttribute("value", newValue.toLocaleString('ru'));ы
        }
      }
      el.value =  formatData(oldValue);
      //el.setAttribute("value", oldValue.toLocaleString('ru'));
      window.requestAnimationFrame(step);
    };
   
    let value_input = parseFloat(el.value.replace(/[^\.\d]/g, ''));
   
   
    if((parseFloat(binding.value) != value_input || parseFloat(binding.value) != parseFloat(binding.oldValue)) && binding.value !== false) {

      
      //el.setAttribute("value", binding.value.toLocaleString('ru'));
      //console.log(el);
      numberAnimation(el, binding.oldValue, binding.value)
    }
  }
});

Vue.use(VueMask);


// export default new vuetify({
//   icons: {
//     iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
//   },
// });
//console.log(window.mixins);
//Vue.use(FileUpload);
//Vue.use(StarRating);
//Vue.use(VueSlick);
//Vue.use(VueSlickCarousel);
//Vue.use(svgicon);

window.axios = axios;
// Vue.use(Vuetify, {

// });
//Vue.use(location);
//Vue.use(UserField);


//console.log(vuetify);

window.bus = new Vue();





//console.log(window);



window.components_vue = {"file-upload":FileUpload, 
// "vue-slider": VueSlider, 
 "action-item":ActionItem,
 "article-item":ArticleItem,
  "aside-window":Aside,
  "comment-item":CommentItem,
  "facades-block":FacadesBlock,
  "figure-gi":Figure,
  //"footer":Footer,
  "header-site":Header,
  "intro":Intro,
  "mobile-filter":MobileFilter,
  //"nav":Nav,  
  //"svg-icon":svgicon,
  "page-block":PageBlock,  
  "page-heading":PageHeading,  
  "quizze":Quizze,  
  "slider-block":SliderBlock,  
  "tips-block":TipsBlock, 
  "map-yandex":Map, 
  "carousel-items":CarouselItems,
 //"star-rating":StarRating, 
 //"vue-slick": VueSlick,
 // "carousel-items":carouselItems,
 // "user-field":UserField,
 // "v-form":Vform,
 // "location":location,
 // "feedbacks-card":Feedbacks,
 // "feedback":feedback,
 // "carousel":carousel,
 // "carousel-mobile":carouselMobile,
 // "v-lazy":VLazy,
 // "v-skeleton-loader":VSkeletonLoader,
 //"icons": mdijs,
 //StarIcon,
 // "v-carousel":VCarousel,
 // "v-carousel-item":VCarouselItem,
 // "snap-carousel":Carousel,
 //"slide":Slide,
 //"tabs":vTabs,
 // "v-tab":VTab,
 // "v-tabs":VTabs,
 // "v-tabs-items":VTabsItems,
 // "v-tab-item":VTabItem,
 // "v-avatar":VAvatar,
 // "v-rating":VRating,
 // "v-badge":VBadge,
 //"vue-slick-carousel":VueSlickCarousel,
 // "listing-card":ListingCard,
 // "listing-card-mobile":ListingCardMobile,
 // "popup-product":PopupProduct,
 //"lazyload-block":lazyloadBlock,
 //"dolyami":dolyami
};

if(typeof window.global_vue !== 'undefined')
{

    //console.log(window.global_vue);
    
  
    window.global_vue.forEach(function(item, index, array) {

      //console.log(vuetify);

        //item["vuetify"] = vuetify;
        //item = vuetify;
        item["components"] = {"file-upload":FileUpload, 
                             // "vue-slider": VueSlider, 
                              "action-item":ActionItem,
                              "article-item":ArticleItem,
                               "aside-window":Aside,
                               "comment-item":CommentItem,
                               "facades-block":FacadesBlock,
                               "figure-gi":Figure,
                               //"footer":Footer,
                               "header-site":Header,
                               "intro":Intro,
                               "mobile-filter":MobileFilter,
                               //"nav":Nav,  
                               //"svg-icon":svgicon,
                               "page-block":PageBlock,  
                               "page-heading":PageHeading,  
                               "quizze":Quizze,  
                               "slider-block":SliderBlock,  
                               "tips-block":TipsBlock, 
                               "map-yandex":Map, 
                               "carousel-items":CarouselItems,
                               "pagination":Pagination,
                              //"star-rating":StarRating, 
                              //"vue-slick": VueSlick,
                              // "carousel-items":carouselItems,
                              // "user-field":UserField,
                              // "v-form":Vform,
                              // "location":location,
                              // "feedbacks-card":Feedbacks,
                              // "feedback":feedback,
                              // "carousel":carousel,
                              // "carousel-mobile":carouselMobile,
                              // "v-lazy":VLazy,
                              // "v-skeleton-loader":VSkeletonLoader,
                              //"icons": mdijs,
                              //StarIcon,
                              // "v-carousel":VCarousel,
                              // "v-carousel-item":VCarouselItem,
                              // "snap-carousel":Carousel,
                              //"slide":Slide,
                              //"tabs":vTabs,
                              // "v-tab":VTab,
                              // "v-tabs":VTabs,
                              // "v-tabs-items":VTabsItems,
                              // "v-tab-item":VTabItem,
                              // "v-avatar":VAvatar,
                              // "v-rating":VRating,
                              // "v-badge":VBadge,
                              //"vue-slick-carousel":VueSlickCarousel,
                              // "listing-card":ListingCard,
                              // "listing-card-mobile":ListingCardMobile,
                              // "popup-product":PopupProduct,
                              //"lazyload-block":lazyloadBlock,
                              //"dolyami":dolyami
                            };
                            //console.log(item["mixins"]);
        //  item["mixins"]                    
        //  window.mixins                    
        // item["mixins"] = [catalog];
        if(item["mixins"])
        {
            item["mixins"].forEach(element => {
              
              
              item["mixins"].push(window.mixins[element]);

              //console.log(window.mixins[element]);
            });
        }
       

       // let result = Object.assign({}, vuetify, item);
        //console.log(item);
        new Vue(item);
        
  });
    
  window.Vue = Vue;
  window.global_vue = [];


  // setTimeout(() => {
  //   GiuliaWebSite.init();
  // }, 500);
  
}